

import React from "react";
import './styles.css';

export default function RegulerInformationArea() {
    return (
        <div className="container-info mt-3">
            <div style={{ fontSize: 14, fontWeight: "600" }}>Keterangan</div>
            <div style={{ marginTop: 24 }}>
                <div className="d-flex">
                    <div style={{ flex: 1 }}>1.</div>
                    <div style={{ flex: 20 }}>
                        Untuk membuat area baru, minimal harus ada 1 provinsi, 1 kota/kabupaten, dan 1 kecamatan.
                    </div>
                </div>

            </div>
        </div>
    );
}
